import { useQuery } from '@tanstack/react-query';
import { fetchSummary } from './fetchSummary';
import { GlobalReactQueryOptions } from '../../config';
import { SelectionListOut } from '../../store/api';
import { browserClient } from '../../react-query';
import { AxiosError } from 'axios';

const QUERY_KEY = 'selectionListSummary';

export const useSelectionListSummary = (listId: string) => {
    return useQuery<SelectionListOut, AxiosError>([QUERY_KEY, listId], () => fetchSummary(listId), {
        ...GlobalReactQueryOptions,
        retry: 0
    });
};

export const invalidateSelectionListSummary = (listId: string) => {
    return browserClient.invalidateQueries({ queryKey: [QUERY_KEY, listId] });
};
